<template>
  <div class="vx-col w-full">
    <vx-card title="Create Footfall">
      <div class="mt-5">
        <form data-vv-scope="step-1">
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-2">
                  <span>Name<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-validate="'required'" type="text" v-model="name"/>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-4">
                  <span>Gender<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio v-model="gender" v-validate="'required'" vs-value="Male">Male</vs-radio>
                    </li>
                    <li>
                      <vs-radio v-model="gender" v-validate="'required'" vs-value="Female">Female</vs-radio>
                    </li>
                    <li>
                      <vs-radio v-model="gender" v-validate="'required'" vs-value="Others">Others</vs-radio>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-2">
                  <span>Email</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" type="email" v-model="email"/>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-4">
                  <span>Mobile<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input @keypress="onlyNumber" class="w-full" v-validate="'required|min:11|max:11'" type="tel" v-model="mobile"/>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-2">
                  <span>Sources</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <v-select label="sources" v-model="sources" class="w-full select-large"
                            :options="sourcesArr" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-4">
                  <span>Reason</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input  class="w-full" type="text" v-model="reason"/>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-2">
                  <span>Product</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <template>
                    <v-select label="product" v-model="product" class="w-full select-large"
                              :options="allproducts" :dir="$vs.rtl ? 'rtl' : 'ltr'" :on-change="selectBrand(product)" />
                  </template>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-4">
                  <span>Brand</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <template>
                    <v-select label="brand" v-model="brand" class="w-full select-large"
                              :options="allBrands" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-2">
                  <span>Follow Up date<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <datepicker :format="customFormatter(reminderDate)" placeholder="Select Date" v-model="reminderDate" v-validate="'required'"></datepicker>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
                     color="success" class="mr-3 mb-2 float-right" @click="updateFootfall" :disabled="!validateForm">Update
          </vs-button>
          <vs-button
            color="warning" class="mr-3 mb-2 float-right" @click="cancel">Cancel
          </vs-button>

        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
  import updateFootfall from '../graphql/UpdateFootfall.gql'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import vSelect from 'vue-select'
  import Datepicker from 'vuejs-datepicker'
  import {products} from '../graphql/products'
  import gql from 'graphql-tag'
  import { Validator } from 'vee-validate';
  import moment from 'moment'
  export default {
    data(){
      return{
        name :'',
        gender :'',
        email :'',
        mobile :'',
        sources :'',
        reason :'',
        product :'',
        brand :'',
        reminderDate :'',
        allproducts:[],
        allBrands:[],
        sourcesArr : ["Online", "TV Ad", "SMS", "Radio", "Others"]
      }
    },
    apollo: {
      footfall: {
        query: gql`
         query footfall($id: ID){
          footfall(id:$id){
            id
            name
            gender
            email
            mobile
            sources
            suffix
            reason
            product
            brand
            reminder_date
            created_at
            updated_at
          }
         }
         `,
        variables () {
          return {
            id: this.$route.params.id
          }
        },
        update: (data) => data.footfall
      },
      productQuer: {
        query: products,
        manual: true,
        result ({data, loading}) {
          if (!loading) {
            this.allproducts = data.products;
            console.log('Product', this.allproducts)
          }
        }
      }

    },
    computed: {
      validateForm () {
        return !this.errors.any() && this.name !== '' && this.gender !== '' && this.mobile !== '' && this.reminderDate !== ''
      }
    },
    watch: {
      footfall (value) {
        if(value !== null){
          this.footFall = value;
          console.log("Footfall = ", this.footFall);
          this.name = value.name;
          this.gender = value.gender;
          this.email = value.email;
          this.mobile = value.mobile;
          this.sources = value.sources;
          this.reason = value.reason;
          this.product = value.product;
          this.brand = value.brand;
          this.reminderDate = value.reminder_date;
        }
      }
    },
    methods :{
      selectBrand(brand){
        console.log("brand",brand);
        this.allBrands = brand.brands;
      },
      customFormatter(reminderDate) {
        return moment(reminderDate).format('yyyy-MM-DD');
      },
      async updateFootfall () {
        this.reminderDate = moment(this.reminderDate).format("yyyy-MM-DD")
        console.log("reminderDate",this.reminderDate);
        await this.$apollo.mutate({
          mutation: updateFootfall,
          variables: {
            id: this.$route.params.id,
            name: this.name || "",
            gender: this.gender|| "",
            email: this.email|| "",
            mobile: this.mobile|| "",
            sources: this.sources|| "",
            reason: this.reason|| "",
            product: this.product.product|| this.product || "",
            brand: this.brand.brand|| this.brand || "",
            reminder_date: this.reminderDate|| "",
          }
        }).then((data) => {
          console.log('Data = ', data);
          this.$router.push('/showroom_footfall').catch(() => {});
          this.$vs.notify({
            title: 'Save',
            text: 'Footfall Successfully Saved.',
            color: "success",
            position: 'top-right'
          })

        }).catch((error) => {
          this.$vs.notify({
            title: 'Error!',
            text: 'Something went wrong.',
            color: "danger",
            position: 'top-right'
          })
        })
      },
      cancel(){
        this.$router.push('/showroom_footfall').catch(() => {});
      },
      onlyNumber($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      }
    },
    components: {
      FormWizard,
      TabContent,
      'v-select': vSelect,
      Datepicker
    }
  }
</script>
<style>
  sup{
    color:red
  }
</style>
